// Components/Home/PortfolioHome.jsx
import React, { useState } from "react";
import { useTenantContent } from "../../Context/TenantContentContext";

const PortfolioHome = () => {
  const { content } = useTenantContent();
  const [showAll, setShowAll] = useState(false);

  if (!content?.portfolioItems || content.portfolioItems.length === 0) {
    return null;
  }

  const portfolioItems = content.portfolioItems;
  const visibleItems = showAll ? portfolioItems : portfolioItems.slice(0, 3);

  return (
    <div className="container pt-4 iran-sans">
      <div className="row justify-content-center">
        {visibleItems.map((item, index) => (
          <div className="col-md-6 col-lg-4 mb-4" key={index}>
            <div className="card border-0 shadow-sm rounded-4 h-100 service-card">
              <img
                src={item.imageUrl}
                alt={item.title}
                className="card-img-top rounded-top-4"
                loading="lazy"
                style={{ height: "250px", objectFit: "cover" }}
              />
              {item.title && (
                <div className="card-body">
                  <h5 className="card-title fw-bold color-blue text-center">
                    {item.title}
                  </h5>
                  {item.description && (
                    <p className="card-text text-secondary-emphasis text-center">
                      {item.description}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* دکمه مشاهده بیشتر */}
      {portfolioItems.length > 3 && (
        <div className="row justify-content-center d-flex">
          <div className="col justify-content-center d-flex gap-2">
            {!showAll ? (
              <button
                className="btn-clear mt-0 fw-bold rounded-5 iran-sans"
                onClick={() => setShowAll(true)}
              >
                مشاهده بیشتر
              </button>
            ) : (
              <button
                className="btn-clear mt-0 fw-bold rounded-5 iran-sans"
                onClick={() => setShowAll(false)}
              >
                نمایش کمتر
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioHome;
